module.exports = __webpack_public_path__ + "static/it-solutions-6b4b30c317994cd33771b9bff4ad73dc.png";